<div class="row">
  <section class="col-xs-12 col-md-6" *ngFor="let i of prices">
    <div class="menuitem-wrap">
      <div class="menuitem">
        <header>
          <h3>{{i.name ? i.name : i.menuItem.name }}</h3>
        </header>
        <p *ngIf="i.description">{{i.description}}</p>

      </div>
      <span class="price" *ngIf="i.price && !isArray(i.price)">{{i.price | cleanPrice}}</span>
    </div>
  </section>
</div>
